module.exports = {
      id: "icons:spinner-solid-usage",
      viewBox: "0 0 512 512",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:spinner-solid-usage",
      toString: function () {
        return this.url;
      }
    }